/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withLocalization } from 'hocs/localization'
import { setScrollElementId } from 'redux-app/modules/pageScroller'
import { getUserRole } from 'redux-app/selectors/auth'
import { onGetSubscriptionsPlans } from 'redux-app/actionCreators/subscription'
import Header from './Header'

export default compose<any, any>(
  connect(
    state => ({
      isUserAuthorized: !!getUserRole(state),
    }),
    {
      setScrollElementId,
      onGetSubscriptionsPlans,
    },
  ),
  withLocalization('header.header'),
  withRouter,
  withHandlers({
    updateSubscriptionPlans: ({ onGetSubscriptionsPlans }) => () => {
      return onGetSubscriptionsPlans()
    },
  }),
)(Header)
